import React from 'react';

import GrowthTableRowImpactCell from './GrowthTableRowImpactCell';

export default function({row_data, impact_data, impact_key, growthMin}) {
    if (!impact_data) {
        return (
            <div className="one-impact one-impact-no-data">
                {`----------------------------------- No data -----------------------------------`}
            </div>
        );
    }

    const render_levels = impact_data.map((level_data, level_key) => {
        return (
            <GrowthTableRowImpactCell
                key={level_key}
                row_data={row_data}
                impact_key={impact_key}
                level_data={level_data}
                level_key={level_key}
                growthMin={growthMin}
            />
        );
    });

    return (
        <div className="one-impact flex-row flex-gap-15">
            {render_levels}
        </div>
    );
}